module.exports = __webpack_public_path__ + "img/mode_comment.d3940a11.svg";